export default {
    install() {
        // Silence Is Golden
    }
};
